export default function TeamSupport() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Support Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
